import { useState, useEffect } from 'react';
import { initPage } from '../App';

const Page3 = () => {

  const [arvoreEnabled, setArvoreEnabled] = useState(false);

  const arvoreText = <span>
    Eu demorei pra entender como as plantas interagem com a ressonância, talvez eu ainda nem entenda completamente. <br/>
    Ainda assim, olha ela aí, grande e forte! Deu certo.
  </span>

  useEffect(() => {
    initPage();
  }, [])

  return (
    <div className="page-container">
      <div style={{ backgroundColor: '#16213e', width: '100%', height: '100%', position: 'relative' }}>
        <img src='/SALA-3.png' alt='Page 3 Background' className='background-image' />

        {/* Porta top direito*/}
        <div
          className="clickable-area seta-direita"
          style={{
            top: '20%',
            left: '65%',
            width: '17%',
            height: '50%',
            opacity: 0.0,
            background: 'red'
          }}
          onClick={() => window.location.href = '/2'}
        />

        {/* Area do texto */}
        {
          arvoreEnabled && (
            <div className="modal-area"
              style={{
                background: "url('/papel-vertical-1.png')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "30ch"
              }}
            >
              <div className="close-button" onClick={() => setArvoreEnabled(false)}
                style={{
                  transform: "translate(-350%, -500%)"
                }}
              >X</div>
              <p
                style={{
                  width: "28ch"
                }}
              >{arvoreText}</p>
            </div>
          )
        }

        {/* Área da árvore 1*/}
        <div
          className="clickable-area"
          style={{
            top: '0%',
            left: '24%',
            width: '20%',
            height: '74%',
            opacity: 0.0,
            background: 'red'
          }}
          onClick={() => setArvoreEnabled(!arvoreEnabled)}
        />

      </div>
    </div>
  );
};

export default Page3;
